<template>
  <article class="article" v-if="article.content">
    <div v-if="hide.indexOf('image') === -1"><img class="image" :src="article.thumbnail | thumbnail(480, 0, undefined, { mode: 0})"></div>
    <p class="source" style="font-size: 14px;">—— 来源：<span class="theme-color" @click="$router.push('/')">涂涂炫</span> {{ article.createTime | formatTime }} ——
      <template v-if="article.source.url">
        <br>
        文章转自<span>{{ article.from || '网络' }}</span>
      </template>
    </p>
    <div class="head" style="font-size: 24px;">{{ article.name }}</div>

    <p class="description">{{ article.description }}</p>
    <div class="content van-hairline--top" v-html="content"></div>

  </article>
</template>

<script>
  import { thumbnail } from '@/filters/'
  import { ImagePreview } from 'vant'

  export default {
    name: "article-main",
    props: {
      article: Object,
      hide: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        images: []
      }
    },
    computed: {
      content() {
        return (this.article.content || '').replace(/(<img[^>]+src="([^>]+)"[^>]*>)/g, (m, $1, $2) => {
          let src = thumbnail($2, 640, 0, undefined, { mode: 0})

          return $1.replace($2, src)
        })
      }
    },

    watch: {
      content: {
        handler(content) {
          if(!content) {
            this.images = []
            return
          }
          setTimeout(() => {
            this.images = [...(this.$el.querySelectorAll('.content img'))].map(item => {
              return item.src.split('?')[0]
            })
          }, 1000)
        },
        // immediate: true
      }
    },
    updated() {
      setTimeout(() => {
        this.$el.querySelector('.content').addEventListener('click', event => {
          let target = event.target

          if(target.tagName === 'IMG') {
            let src = target.src.split('?')[0]
            ImagePreview(this.images, this.images.findIndex(item => item === src))
          }
        })

      }, 1000)
    },
    deactivated() {
      // 清楚预览缓存
      let ipv = ImagePreview([])

      this.$nextTick(() => {
        ipv.close()
      })
    }
  }
</script>

<style lang="less" scoped>
  .image {
    width: 100%;
    /*width: 7.5rem;*/
    /*height: 5.16rem;*/
  }
  .source {
    text-align: center;
    padding: 10px 0;
  }
  .head {
    font-size: 24px;
    line-height: 32px;
    // font-weight: bold;
    text-align: center;
    padding: 10px 0.75rem;
    margin: 0 auto;
    color:rgba(30,30,30,1);
  }

  .description {
    // font-size: 14px;
    font-size:18px;
    line-height: 18px;
    margin-bottom: 15px;
    padding: 10px 24px;
    color:rgba(65,65,65,1);
  }

  .content {
    padding: 0.75rem 24px;
    font-size:18px;
    color:rgba(65,65,65,1);
  }
  .content[class*=van-hairline]::after {
    border-color: #d7b563;
  }
  .content/deep/img {
    max-width: 100%;
  }
</style>